/**
 * Cruise imagery — same CDN sources as travelnodex/src/constants/images.js
 * Pexels: https://www.pexels.com/license/
 * Unsplash: https://unsplash.com/license
 */

const pexels = (id, width = 1400) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${width}`;

const pexelsSlug = (id, slug, width = 1400) =>
  `https://images.pexels.com/photos/${id}/${slug}-${id}.jpeg?auto=compress&cs=tinysrgb&w=${width}`;

const unsplash = (photoId, width = 1400) =>
  `https://images.unsplash.com/${photoId}?auto=format&fit=crop&w=${width}&q=80`;

export const CRUISE_IMAGES = {
  /** Golden-hour cruise ship (1090244 removed from Pexels — use verified slug URL) */
  hero: pexelsSlug(144237, 'cruise-ship-cruiser-cruise-ship', 2000),
  cruiseShip: pexelsSlug(144237, 'cruise-ship-cruiser-cruise-ship'),
  cruiseDeck: unsplash('photo-1758334296129-978df3db9db8'),
  caribbean: pexels(2634269),
  mediterranean: pexels(813011),
  alaska: pexelsSlug(69122, 'ferry-boat-ferry-ship-boat'),
  northernEurope: pexels(173910),
  tropicalBeach: pexelsSlug(68737, 'cruise-ship-holidays-cruise-vacation'),
  atPort: pexelsSlug(68737, 'cruise-ship-holidays-cruise-vacation'),
};

export const CRUISE_HERO_IMAGE = CRUISE_IMAGES.hero;
export const CRUISE_SEARCH_BANNER = CRUISE_IMAGES.cruiseShip;

/** Region → cruise sailing image (travelnodex mockData mapping) */
export const CRUISE_REGION_IMAGES = {
  Caribbean: CRUISE_IMAGES.caribbean,
  Mediterranean: CRUISE_IMAGES.mediterranean,
  Alaska: CRUISE_IMAGES.alaska,
  'Northern Europe': CRUISE_IMAGES.northernEurope,
  'Asia Pacific': CRUISE_IMAGES.cruiseDeck,
  'South America': CRUISE_IMAGES.tropicalBeach,
};

/** Departure port → sailing region */
export const CRUISE_PORT_REGION = {
  Miami: 'Caribbean',
  'Fort Lauderdale': 'South America',
  Barcelona: 'Mediterranean',
  Seattle: 'Alaska',
  Copenhagen: 'Northern Europe',
  Singapore: 'Asia Pacific',
};

export const CRUISE_PORT_META = {
  Miami: { city: 'Miami', country: 'Florida, USA' },
  'Fort Lauderdale': { city: 'Fort Lauderdale', country: 'Florida, USA' },
  Barcelona: { city: 'Barcelona', country: 'Spain' },
  Seattle: { city: 'Seattle', country: 'Washington, USA' },
  Copenhagen: { city: 'Copenhagen', country: 'Denmark' },
  Singapore: { city: 'Singapore', country: 'Singapore' },
};

/** Deal-specific images (matches travelnodex CRUISE_DEALS) */
export const CRUISE_DEAL_IMAGES = {
  Caribbean: CRUISE_IMAGES.cruiseShip,
  Mediterranean: CRUISE_IMAGES.mediterranean,
  Alaska: CRUISE_IMAGES.alaska,
  'Northern Europe': CRUISE_IMAGES.cruiseDeck,
  'Asia Pacific': CRUISE_IMAGES.mediterranean,
  'South America': CRUISE_IMAGES.tropicalBeach,
};

export function getRegionImage(region, wide = false) {
  const image = CRUISE_REGION_IMAGES[region] || CRUISE_IMAGES.cruiseShip;
  return wide && region === 'Caribbean' ? CRUISE_IMAGES.hero : image;
}

export function getPortImage(port, wide = false) {
  const region = CRUISE_PORT_REGION[port];
  return region ? getRegionImage(region, wide) : CRUISE_IMAGES.cruiseShip;
}

export function getDealImage(destination) {
  return CRUISE_DEAL_IMAGES[destination] || CRUISE_IMAGES.cruiseShip;
}

export function getCruiseCityMeta(port) {
  const meta = CRUISE_PORT_META[port] || { city: port, country: '' };
  const region = CRUISE_PORT_REGION[port] || '';
  return {
    ...meta,
    region,
    image: getPortImage(port),
  };
}

/** @deprecated Use getPortImage or getRegionImage */
export function getCruiseCityImage(port) {
  return getPortImage(port);
}

/** @deprecated Use getRegionImage */
export function getRegionCityImage(region, wide = false) {
  return getRegionImage(region, wide);
}
